export default "__VITE_ASSET__Bvm8Pxx7__"